import { OptionType } from '@shipae/components-sandbox/component/select';

export const buildOptions = (values: string[]): OptionType[] => [...values]
  .filter((value) => !!value && value.trim() !== '')
  .map((value) => ({
    label: value.trim(),
    value: value.trim(),
  }));
